import { MoveableOverlay } from "./MoveableOverlay";

export class MoveableOverlayShape extends MoveableOverlay {

	type: string = "shape";

	file: any;
	style: any;

	constructor(variationId: string, twinnedId: string) {
		super(variationId, twinnedId);

		this.file = null;
		this.style = {
			color: '#ffffff'
		};

		this.position = 'center';
		this.moveableObject = {
			draggable: true,
			throttleDrag: 0,
			resizable: false,
			throttleResize: 1,
			keepRatio: false,
			scalable: true,
			throttleScale: 1,
			rotatable: true,
			throttleRotate: 0,
			pinchable: true, // ["draggable", "resizable", "scalable", "rotatable"]
			origin: false,
			snappable: true,
			snapVertical: true,
			snapHorizontal: true,
			snapElement: true,
			snapThreshold: 0,
			snapCenter: true,
		};
		this.moveabaleStyle = {
			width: "23%",
			//height: "30%",
			left: "unset",
			top: "unset",
			//right: 0,
			//bottom: 0,
			position: "absolute",
			userSelect: "none"
		};
	}

	copyProperties(overlayToCopy: MoveableOverlayShape) {
		super.copyProperties(overlayToCopy);

		this.file = JSON.parse(JSON.stringify(overlayToCopy.file));
		this.style = JSON.parse(JSON.stringify(overlayToCopy.style));
	}

	copy(): MoveableOverlayShape {
		let copy = new MoveableOverlayShape(this.variationId, this.twinnedId);

		copy.copyProperties(this);
		return copy;
	}

	static copyFromParsed(parsedObject: any): MoveableOverlayShape {
		let copy = new MoveableOverlayShape(parsedObject.variationId, parsedObject.twinnedId ? parsedObject.twinnedId : null);

		copy.copyProperties(parsedObject);
		return copy;
	}

	hexToRgb(hex) {
		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		} : null;
	}

	async colorizeAndGetImage(width, height, baseURL) {
		return new Promise(resolve => {
			let canvas = document.createElement("canvas");
			let ctx = canvas.getContext("2d");

			canvas.width = width;
			canvas.height = height;

			let svg = new Image();
			let rgbColor = this.hexToRgb(this.style.color);
			let scaleX = this.transforms.scaleX;
			let scaleY = this.transforms.scaleY;

			svg.onload = function () {
				let imageWidth = width;
				//TODO нужно быть аккуратным и проверить на реальных шейпах. Может что-то быть не так
				let imageHeight = svg.width !== svg.height ? (svg.height * scaleY) * width / (svg.width * scaleX) : height;
				// create temporary canvas
				let svgCanvas = document.createElement("canvas");
				let svgCtx = svgCanvas.getContext("2d");
				svgCanvas.width = width;
				svgCanvas.height = height;
				// draw the actual svg image to temporary canvas
				let dif = height !== imageHeight ? (height - imageHeight) / 2 : 0;
				svgCtx.drawImage(svg, 0, dif, imageWidth, imageHeight);
				// get ImageData object
				let svgData = svgCtx.getImageData(0, 0, width, height);
				// get pixel data
				let data = svgData.data;
				// loop through data
				for (let i = 0; i < data.length; i += 4) {
					// check if pixel alpha value is not 0, then change the data
					if (data[i + 3] !== 0) {
						data[i] = rgbColor.r; // pixel red value
						data[i + 1] = rgbColor.g; // pixel green value
						data[i + 2] = rgbColor.b; // pixel blue value
					}
				}
				// put the data back to the temporary svg canvas
				svgCtx.putImageData(svgData, 0, 0);
				// draw temporary canvas to the real canvas
				ctx.drawImage(svgCanvas, 0, 0);
				resolve(canvas.toDataURL('image/png'));
			}

			svg.crossOrigin = "Anonymous";
			svg.src = baseURL + this.file.path;
		});
	}

	async getShapeImage(videoPreviewPixelsWidth, outerVideoResolutionX, videoScale, currentSize, baseURL) {
		if (!this.file) {
			return {
				image: "",
				x: 0,
				y: 0,
				w: 0,
				h: 0
			};
		}

		let upscale = 2;
		let outerVideoWidth = outerVideoResolutionX;
		let p = outerVideoWidth / videoPreviewPixelsWidth;
		let k = p * videoScale * upscale;

		let overlayCenterXY = this.getOverlayCenterXY(videoPreviewPixelsWidth, currentSize);
		let x = overlayCenterXY.x * k;
		let y = overlayCenterXY.y * k;
		let w = this.offsetDimensions.width * k * this.transforms.scaleX;
		let h = this.offsetDimensions.height * k * this.transforms.scaleY;

		let image = await this.colorizeAndGetImage(w, h, baseURL);

		return {
			image: image,
			x: x / upscale,
			y: y / upscale,
			w: w / upscale,
			h: h / upscale
		};
	}
}